import { useQuery } from '@tanstack/react-query'
import { fetchJobberMetrics } from '../api/metrics'
import type { FilterState, DashboardMetrics } from '@/types/lead-attribution'
import { jobberQueryKeys } from './queryKeys'

export function useJobberMetrics(filters: FilterState) {
  return useQuery<DashboardMetrics>({
    queryKey: jobberQueryKeys.metrics.dashboard(filters),
    queryFn: () => fetchJobberMetrics(filters),
  })
}
